function generateSpacingClasses(property: string, prefix: string, range: number[]) {
    return range.reduce(
        (styles, value) => {
            styles[`& .${prefix}-${value}`] = {
                [property]: value,
            };
            return styles;
        },
        {} as Record<string, object>
    );
}

export const cmsHtmlStyles = {
    typography: 'body1',
    '& img': {
        maxWidth: '100%',
        height: 'auto',
        '&.left': {
            float: 'left',
            maxWidth: '50%',
            margin: '5px 20px 10px 0',
        },
        '&.right': {
            float: 'right',
            maxWidth: '50%',
            margin: '5px 0 10px 20px',
        },
        '&.leftAlone': {
            float: 'left',
            marginRight: '100%',
            marginBottom: '10px',
            clear: 'both',
        },
        '&.rightAlone': {
            float: 'right',
            marginLeft: '100%',
            marginBottom: '10px',
            clear: 'both',
        },
        '&.center': {
            float: 'none',
            marginLeft: 'auto',
            marginRight: 'auto',
            display: 'block',
            marginBottom: '10px',
            clear: 'both',
        },
    },
    '& .flex': {
        display: 'flex',
    },
    '& .items-center': {
        alignItems: 'center',
    },
    '& .justify-center': {
        justifyContent: 'center',
    },
    '& .text-jucy-green': {
        '&, & a': {
            color: 'secondary.main',
        },
    },
    '& .grid-container': {
        '& > * > p:first-child ': {
            marginTop: 0,
        },
    },
    '& .grid-50-50': {
        display: 'flex',
        flexWrap: {
            xs: 'nowrap',
            md: 'wrap',
        },
        gap: {
            xs: 4,
            md: 8,
        },
        '& > * > p:first-child ': {
            marginTop: 0,
        },
        '& > *': {
            flex: {
                xs: '1 1 100%',
                md: '1 1 50%',
            },
        },
    },
    '& .text-center': {
        textAlign: 'center',
    },
    '& .text-uppercase': {
        textTransform: 'uppercase',
    },
    '& .embed': {
        position: 'relative',
        width: '100%!important',
        '&:before': {
            content: '""',
            display: 'block',
            paddingTop: '57.037%',
        },
        '& iframe': {
            inset: 0,
            border: 0,
            height: '100%',
            position: 'absolute',
            width: '100%',
        },
    },
    '& .h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6': {
        fontWeight: 600,
        lineHeight: 1.2,
        marginBottom: '.5rem',
        marginTop: '0',
    },
    '& .h1,h1': { font: 'var(--mui-font-h1)' },
    '& .h2,h2': { font: 'var(--mui-font-h2)' },
    '& .h3,h3': { font: 'var(--mui-font-h3)' },
    '& .h4,h4': { font: 'var(--mui-font-h4)' },
    '& .h5,h5': { font: 'var(--mui-font-h5)' },
    '& .h6,h6': { font: 'var(--mui-font-h6)' },
    ...generateSpacingClasses('gap', 'gap', [1, 2, 3, 4, 5, 6, 7, 8]),
    ...generateSpacingClasses('marginTop', 'mt', [1, 2, 3, 4, 5, 6, 7, 8]),
};
